/* eslint-disable react-hooks/exhaustive-deps */
import { getCssDemention } from "src/libs/utilities"
import { ICardFieldProps } from "../cards/CardField"
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"

/* Protopia Ecosystem component */
const CardFieldEmpty = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
    const width = getCssDemention(field.style?.width || value.style?.width, "100%") 
    const height = getCssDemention(field.style?.height || value.style?.height, "120px") 
    useEffect(() => {            
        addCSSClass(
            `landing-card-field-empty-${section.id + "-" + value.id}`,
            `.landing-card-field-empty-${section.id + "-" + value.id} {
                height: ${height}!important;
                max-height: ${height}!important; 
            } 
            `
        )
        return () => removeCSSClass(`landing-card-field-empty-${section.id + "-" + value.id}`)
    }, []) 
    return <div 
        className={`landing-card-field landing-card-field-empty landing-card-field-empty-${section.id + "-" + value.id} ${value?.className || ""}`} 
        style={{ ...field.style, ...value.style }} 
        data-card-field-id={i}
        card-field-section-id={section.id}
    >
        <div className="before" />
        <div className="before-2" />
        <div className="before-3" />
        
        <div className="after" />
        <div className="after-2" />
        <div className="after-3" />
    </div>
}
export default CardFieldEmpty